export default "/_next/static/images/7dd04847fee2025b258a4a87458a6a20.png";